var map = {
	"./en/example.yml": 153,
	"./en/hos.yml": 154,
	"./en/main.yml": 30,
	"./en/markdown.yml": 155,
	"./en/news.yml": 156,
	"./en/sfs.yml": 157,
	"./fr/example.yml": 158,
	"./fr/hos.yml": 159,
	"./fr/main.yml": 31,
	"./fr/markdown.yml": 160,
	"./fr/news.yml": 161,
	"./fr/sfs.yml": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;